import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { DietCategoryIndexResponse } from "./types/residents/responses/DietCategoriesIndexResponse";
import { OtherInformationResponse } from "./types/residents/responses/OtherInformationCategoriesResponse";

export const categoriesApi = createApi({
  reducerPath: "categoriesApi",
  baseQuery: DynamicBaseQuery,
  keepUnusedDataFor: Infinity,
  tagTypes: [],
  endpoints: (builder) => ({
    getDietCategories: builder.query<DietCategoryIndexResponse, undefined>({
      query: () => ({
        url: "/diet-categories",
        method: "GET",
      }),
    }),
    getOtherInformationCategories: builder.query<
      OtherInformationResponse,
      void
    >({
      query: () => ({
        url: "/other-information-categories",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetDietCategoriesQuery,
  useGetOtherInformationCategoriesQuery,
  usePrefetch: usePrefetchCartegories,
} = categoriesApi;
